<template>
  <div id="system-journal-setting-article-type-setting">
    <div class="mar-b-20">
      <site-search-group v-model.trim="params.keyword"
                         placeholder="Search for Name / Other Name"
                         @search="getList()"
                         @clear="handleClear" />
    </div>
    <div class="mar-b-20">
      <span class="ipub-p2 fw-bd line-h-40"
            style="display:inline-block;width:160px">Publishing Suggestions</span>
      <ipub-select style="width:400px"
                   v-model="params.publishSuggestion"
                   :clear="true"
                   placeholder="Choose Publishing Suggestions"
                   @change="getList()">
        <ipub-select-option v-for="(value, key) in publishSuggestions"
                            :key="key"
                            :value="key">{{value}}</ipub-select-option>
      </ipub-select>
    </div>
    <div class="relative line-h-40 mar-b-20">
      <div class="ipub-tab-list">
        <a @click="changeStatus('')"
           :class="['ipub-tab-list--tab',params.released===''?'active':'']">All</a>
        <a @click="changeStatus(true)"
           :class="['ipub-tab-list--tab',params.released===true?'active':'']">Published</a>
        <a @click="changeStatus(false)"
           :class="['ipub-tab-list--tab',params.released===false?'active':'']">Draft</a>
      </div>

      <div class="right-option ipub-p1">
        <ipub-button v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.ARTICLE_TYPE_SETTING.ARTICLE_TYPE_SETTING')"
                     @click="handlerSetting('articleType')"
                     type="primary">Article Type Setting</ipub-button>
        <ipub-button v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.ARTICLE_TYPE_SETTING.PUBLISHING_SUGGESTION_SETTING')"
                     @click="handlerSetting('publishingSuggestion')"
                     type="primary">Publishing Suggestion Setting</ipub-button>
      </div>
    </div>
    <div>
      <ipub-table :columns="columns"
                  fixed
                  draggable
                  @drag="setSort"
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:countryName="{text}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text&&text.name||'--'}`" />
        </template>
        <template v-slot:otherName="{text}">
          <ipub-tooltip style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="`${text&&text.otherName||'--'}`" />
        </template>
        <template v-slot:publishSuggestion="{ text }">
          <div>
            <ipub-label cover
                        v-if="text === 'ENCOURAGE'"
                        style="width:120px"
                        type="success"
                        size="small">{{publishSuggestions[text]}}</ipub-label>
            <ipub-label cover
                        v-else-if="text === 'NOT_RECOMMENDED'"
                        style="width:120px"
                        type="danger"
                        size="small">{{publishSuggestions[text]}}</ipub-label>
            <ipub-label cover
                        v-else
                        style="width:120px"
                        type="default"
                        size="small">{{publishSuggestions[text]}}</ipub-label>
          </div>
        </template>
        <template v-slot:email="{ text }">
          <ipub-tooltip v-if="text&&text.email"
                        style="width:100%"
                        placement="bottomLeft"
                        omis="omis"
                        :label="text.email" />
          <template v-else>- -</template>
        </template>
        <template v-slot:status="{text}">
          <template v-if="text">
            <ipub-label cover
                        style="width:80px"
                        type="success"
                        size="small">In Use</ipub-label>
          </template>
          <template v-else>
            <ipub-label cover
                        style="width:80px"
                        type="danger"
                        size="small">Unused</ipub-label>
          </template>
        </template>
        <template v-slot:date="{ text, record }">
          {{text?$moment(text).format('HH:mm DD/MM/YYYY'):record.createTime?$moment(record.createTime).format('HH:mm DD/MM/YYYY'):'--'}}
        </template>
        <template v-slot:actions="{ record }">
          <template v-if="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.ARTICLE_TYPE_SETTING.PUBLISH')">
            <ipub-tooltip v-if="record.released"
                          class="border-right">
              <div slot="title">Unpublish</div>
              <ipub-icon type="iconDisable"
                         @click="able(record)" />
            </ipub-tooltip>
            <ipub-tooltip v-else
                          class="border-right">
              <div slot="title">Publish</div>
              <ipub-icon type="iconAble"
                         @click="able(record)" />
            </ipub-tooltip>
          </template>
          <ipub-tooltip v-show="user.codeList&&user.codeList.includes('SYSTEM.JOURNAL_SETTING.ARTICLE_TYPE_SETTING.EDIT')">
            <div slot="title">Edit</div>
            <ipub-icon type="iconEditPen"
                       @click="edit(record)" />
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
    <PublishingSuggestionSetting :isVisable="publishingSuggestionVisable"
                                 :journalId="journalId"
                                 @confirm="confirm"
                                 @cancel="cancel" />
    <ArticleTypeSetting :isVisable="articleTypeVisable"
                        :journalId="journalId"
                        @confirm="confirm"
                        @cancel="cancel" />
    <Add :isVisable="addVisable"
         :inputData="inputData"
         @confirm="confirm"
         @cancel="cancel" />
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
